const React = require('react');
const { InputText } = require('components/inputText/inputText');
const CheckBox = require('components/checkBox/checkBox');
import { formatText } from 'core/i18n';
import { getIncomesData } from 'constants/fioc';

const validator = require('validator');

class Incomes extends React.Component {
    constructor(props) {
        super(props);

        this.buildExtraField = this.buildExtraField.bind(this);
        this.handleDataToSave = this.handleDataToSave.bind(this);
        this.handleClickOther = this.handleClickOther.bind(this);
        this.generatedIncomes = this.generatedIncomes.bind(this);
    }

    generatedIncomes() {
        const { userProfile } = this.props;

        const incomes = {
            work: typeof userProfile['income_work'] !== 'undefined' ? userProfile['income_work'] : false,
            activities:
                typeof userProfile['income_activities'] !== 'undefined' ? userProfile['income_activities'] : false,
            business: typeof userProfile['income_business'] !== 'undefined' ? userProfile['income_business'] : false,
            realState: typeof userProfile['income_realState'] !== 'undefined' ? userProfile['income_realState'] : false,
            other:
                typeof userProfile['income_description'] !== 'undefined' && userProfile['income_description'] !== ''
                    ? userProfile['income_description']
                    : null,
        };

        return incomes;
    }

    handleDataToSave(name, value) {
        const { handleSave } = this.props;
        let incomes;
        incomes = this.generatedIncomes();
        incomes[name] = value;
        handleSave('income', incomes);
    }

    handleClickOther(value) {
        const { formActions, handleSave } = this.props;
        if (!value) {
            formActions.change('userProfile.income_description', '');

            let incomes;
            incomes = this.generatedIncomes();
            incomes['other'] = null;
            formActions.setValidity('userProfile.income_description', { required: true });
            handleSave('income', incomes);
        }
    }

    buildExtraField(model, otherLabel) {
        // For "Other" checked.
        const { userProfile, userProfileForm, formActions, disabled } = this.props;
        const handleSave = this.props.handleSave;
        const generatedIncomes = this.generatedIncomes;

        return (
            <div className="other-input">
                <InputText
                    profileModel={model}
                    label={otherLabel}
                    userProfile={userProfile}
                    userProfileForm={userProfileForm}
                    formActions={formActions}
                    validations={{
                        required: value => value && value.length,
                        valid: value => validator.matches(value, /^[a-zA-ZÀ-ÄÇ-ÏÑ-ÖÙ-Üà-äç-ïñ-öù-ü\s]*$/),
                    }}
                    isValidated={function () {
                        const modelName = model.split('.')[1];
                        let incomes;
                        incomes = generatedIncomes();
                        incomes['other'] = userProfile[modelName];

                        handleSave('income', incomes);
                    }}
                    messagesError={{
                        required: formatText('validation-fieldRequired'),
                        valid: formatText('validation-syntaxError'),
                    }}
                    disabled={disabled}
                    maxLength={40}
                    focusAnimated
                />
            </div>
        );
    }

    render() {
        const { userProfile, userProfileForm, formActions, disabled } = this.props;
        const others = 'income_other';
        let otherView;

        if (userProfile[others] === true) {
            otherView = this.buildExtraField('userProfile.income_description', formatText('field-otherIncomes'));
        }

        return (
            <div>
                <label>{formatText('field-hasPublicOfficeIncome')}</label>
                <label className="sub-label">{formatText('field-checkMoreThanOne')}</label>
                <CheckBox
                    profileModel={'userProfile.is_income'}
                    fieldsRequired="1"
                    checkBoxList={getIncomesData(this.handleDataToSave, this.handleClickOther)}
                    userProfile={userProfile}
                    userProfileForm={userProfileForm}
                    formActions={formActions}
                    focusAnimated
                    disabled={disabled}
                    checkBoxListErrorMessage={formatText('validation-fieldRequired')}
                />
                {otherView}
            </div>
        );
    }
}

React.propTypes = {};

React.defaultProps = {};

module.exports = Incomes;
